import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { AppSide, AppStatesTexts } from 'src/app/constants';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-states-filter',
  templateUrl: './states-filter.component.html',
  styleUrls: ['./states-filter.component.scss']
})
export class StatesFilterComponent implements IFilterAngularComp {

  params: IFilterParams;
  filterText = '';

  selectedState = 'All';

  allStates = [];

  destroySubscription = false;

  appStatesTexts = AppStatesTexts;

  isAllData: false;

  constructor(private sharedService: SharedService) { }

  agInit(params: IFilterParams): void {
    this.params = params;
    const fromSide = this.params.context.componentParent.formSide;
    if (fromSide === AppSide.manageSide) {
      const manageMetadata = this.sharedService.getMetadata();
      this.allStates = manageMetadata && manageMetadata.partner_app_enable_states ? manageMetadata.partner_app_enable_states : [];
    } else if (fromSide === AppSide.storeSide) {
      const storeMetadata = this.sharedService.getStoreMetadata();
      this.allStates = storeMetadata && storeMetadata.customer_app_enable_states ? storeMetadata.customer_app_enable_states : [];
    }
  }

  checkHidden(state: string) {
    return (!this.isAllData && state === AppStatesTexts.available) || 
    (!this.isAllData && state === AppStatesTexts.enabled);
  }

  isFilterActive(): boolean {
    return this.selectedState != 'All';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    const { node } = params;
    const nodeData = { node };
    // console.log(nodeData);
    const value = nodeData.node.data.enable_state;
    let tempState = this.selectedState.toLocaleUpperCase();
    if (tempState === AppStatesTexts.readytoPublishText) {
      tempState = AppStatesTexts.readytoPublish;
    } else if (tempState === AppStatesTexts.readytoActivateText) {
      tempState = AppStatesTexts.readytoActivate;
    }
    return tempState === value;
  }

  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }

    return { value: this.selectedState };
  }

  setModel(model: any) {
    this.selectedState = model == null ? null : model.value;
  }

  onChange(newValue: any) {
    this.selectedState = newValue;
    this.params.filterChangedCallback();
  }

  destroy() {
    this.destroySubscription = true;
  }

  afterGuiAttached(params?: IAfterGuiAttachedParams): void {
    // console.log('changes', params, this.params.context.componentParent.tableConfigOptions.allData);
    this.isAllData = this.params.context.componentParent.tableConfigOptions.allData;
  }
}
